module.exports = __webpack_public_path__ + "staticcomp/img/cover.69d0daa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/7/cover.jpg
// module id = PgHz
// module chunks = 39